export class SignUpControl {
  get disabled() {
    return this.$element.disabled;
  }
  set disabled(value) {
    this.$element.disabled = value;
  }

  get hidden() {
    return this.$element.hidden;
  }
  set hidden(value) {
    this.$element.hidden = value;
  }

  constructor(private readonly $element: HTMLButtonElement) {}

  focus() {
    this.$element.focus();
  }

  registerInteractionHandler(type: string, listener: EventListener) {
    this.$element.addEventListener(type, listener);
  }

  deregisterInteractionHandler(type: string, listener: EventListener) {
    this.$element.removeEventListener(type, listener);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/shared/ui/sign-up-control.ts